import { useEffect, useRef, useState } from 'react';
import mermaid from 'mermaid';

let initialized = false;
function ensureInit() {
  if (initialized) return;
  mermaid.initialize({
    startOnLoad: false,
    securityLevel: 'strict',
    theme: 'neutral',
    flowchart: { useMaxWidth: true, htmlLabels: true },
  });
  initialized = true;
}

/**
 * Renders a Mermaid diagram from source. Used by the compliance document
 * viewer to turn ```mermaid code fences into real SVG diagrams. On parse
 * error it falls back to showing the source so the author can fix it.
 */
export function MermaidDiagram({ code }: { code: string }) {
  const [svg, setSvg] = useState<string>('');
  const [error, setError] = useState<string | null>(null);
  const idRef = useRef(`mmd-${Math.random().toString(36).slice(2)}`);

  useEffect(() => {
    let active = true;
    ensureInit();
    mermaid
      .render(idRef.current, code)
      .then((res) => {
        if (active) {
          setSvg(res.svg);
          setError(null);
        }
      })
      .catch((e: unknown) => {
        if (active) setError(e instanceof Error ? e.message : String(e));
      });
    return () => {
      active = false;
    };
  }, [code]);

  if (error) {
    return (
      <div className="my-4 rounded border border-destructive/30 bg-destructive/5 p-3">
        <p className="text-xs text-destructive mb-1">Diagramma non valido: {error}</p>
        <pre className="text-xs overflow-x-auto whitespace-pre-wrap">{code}</pre>
      </div>
    );
  }

  return (
    <div
      className="my-4 flex justify-center overflow-x-auto rounded border border-border/50 bg-card p-3"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
}

export default MermaidDiagram;
